export const extractAttributesValues = (attributes = [], attributesList) => {
  return attributes.reduce((acc, item) => {
    const { attribute_code, value } = item;

    if (attributesList.includes(attribute_code)) {
      acc[attribute_code] = value;
    }

    return acc;
  }, {});
};

export const expirationList = [
  { label: '1 Day', value: 1 },
  { label: '5 Days', value: 5 },
  { label: '10 Days', value: 10 },
  { label: '15 Days', value: 15 },
  { label: '30 Days', value: 30 },
  { label: '50 Days', value: 50 },
  { label: '70 Days', value: 70 },
  { label: '90 Days', value: 90 },
  { label: '110 Days', value: 110 }
];

export const statusActivityNames = {
  '0': { title: 'Created', color: '#FFD700' },
  '1': { title: 'Pending', color: '#FFD700' },
  '2': { title: 'Approved', color: '#00FF00' },
  '3': { title: 'Complete', color: '#32CD32' },
  '4': { title: 'Canceled', color: '#FF4500' },
  '5': { title: 'Expired', color: '#8A2BE2' },
  '6': { title: 'Held', color: '#4169E1' },
  '7': { title: 'Created by admin', color: '#E9EDF5' }
};

export const quoteStatuses = [
  {name: 'All', value: ''},
  {name: 'Created', value: 0},
  {name: 'Pending', value: 1},
  {name: 'Approved', value: 2},
  {name: 'Complete', value: 3},
  {name: 'Canceled', value: 4},
  {name: 'Expired', value: 5},
  {name: 'Held', value: 6},
];

export function getAlleDiscount(productData): number {
  const priceRegex = /\d+/;
  const isAlleProduct = productData?.sku?.includes('bdsku');
  const [alleDiscount] = isAlleProduct && productData.name ? (productData.name.match(priceRegex)) : [0];
  return Number(alleDiscount);
}

export function transformItemsToProducts(items, quoteProducts, subscriptionOptionsBySku) {
  const transformedData = {};

  items.forEach((item) => {
    const product = quoteProducts.find((product) => product.sku === item.sku);
    const customAttributes = {};
    product.custom_attributes.forEach((attr) => {
      customAttributes[attr.attribute_code] = attr.value;
    });

    const transformedProduct = {
      product: {
        id: product.id,
        sku: product.sku,
        name: product.name,
        price: product.price,
        custom_attributes: product.custom_attributes,
        subscription_active: product.custom_attributes.find((attr) => attr.attribute_code === 'subscription_active')?.value,
        subscription_options: subscriptionOptionsBySku?.[product.sku],
        additional_subscription_price: product.custom_attributes.find((attr) => attr.attribute_code === 'additional_subscription_price')?.value,
        discount_options: product.quotepro_discounts ? JSON.parse(product.quotepro_discounts) : [],
        savings: product.custom_attributes.find((attr) => attr.attribute_code === 'savings')?.value,
        catalog_quotepro_groups: product.custom_attributes.find((attr) => attr.attribute_code === 'catalog_quotepro_groups')?.value,
      }
    };

    transformedData[product.sku] = transformedProduct;
  });

  return transformedData;
}

export function calculateSavings(discountType, discount, fixedPrice, savings, qty) {
  let savingsValue = 0;

  if (!discountType?.length) {
    savingsValue = 0;
  } else if (discountType === 'fixed') {
    savingsValue = discount;
  } else if (discountType === 'percent') {
    savingsValue = (fixedPrice * discount / 100);
  }

  savingsValue = (Math.abs(Math.round(savingsValue * 100) / 100) || +savings || 0) * qty;

  return savingsValue;
}

export function compareSubscriptionPeriods(selectedItems, pushCartProducts) {
  const uniqueSubscriptionPeriods = new Set();

  for (const item of selectedItems) {
    const { sku } = item;
    const product = pushCartProducts[sku]?.product;

    if (product?.subscription_options?.length) {
      const subscriptionPeriods = product.subscription_options.reduce((acc, subscription) => {
        const { frequency_unit, frequency_count } = subscription;

        if (frequency_unit && frequency_count) {
          acc.push(`${frequency_count}_${frequency_unit}`);
        }

        return acc;
      }, []);

      uniqueSubscriptionPeriods.add(JSON.stringify(subscriptionPeriods.sort()));
    }
  }

  return uniqueSubscriptionPeriods.size <= 1;
}
